import { render, staticRenderFns } from "./BbSelectChildren.vue?vue&type=template&id=96b524e4"
import script from "./BbSelectChildren.vue?vue&type=script&lang=js"
export * from "./BbSelectChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports